import * as z from "zod";
import { Id } from "./ids.js";

export const TaskStepSchema = z.object({
  id: z.string().trim().min(1).max(64),
  title: z.string().trim().min(1).max(120),
  status: z.enum(["pending", "working", "done"]),
});
export const TaskPlanSchema = z
  .object({
    title: z.string().trim().min(1).max(120),
    steps: z.array(TaskStepSchema).max(12),
    outcome: z.enum(["working", "review", "done"]),
    summary: z.string().trim().max(500),
  })
  .refine((plan) => new Set(plan.steps.map((step) => step.id)).size === plan.steps.length, {
    message: "Step ids must be unique",
  })
  .refine(
    (plan) => plan.outcome === "working" || plan.steps.every((step) => step.status === "done"),
    {
      message: "Finish each step before requesting review or reporting completion",
    },
  );
export type TaskPlan = z.infer<typeof TaskPlanSchema>;
export const ConversationTaskStatusSchema = z.enum([
  "queued",
  "working",
  "needs_input",
  "review",
  "done",
  "paused",
  "failed",
  "cancelled",
]);
export type ConversationTaskStatus = z.infer<typeof ConversationTaskStatusSchema>;
export const ConversationTaskSchema = z.object({
  taskId: Id,
  runId: Id,
  title: z.string(),
  steps: z.array(TaskStepSchema),
  summary: z.string(),
  status: ConversationTaskStatusSchema,
  outcome: z.enum(["working", "review", "done"]),
  messageId: Id.optional(),
});
export type ConversationTask = z.infer<typeof ConversationTaskSchema>;

export const TaskSuggestionInputSchema = z.object({
  title: z.string().trim().min(1).max(120),
  prompt: z.string().trim().min(1).max(2000),
});
export const TaskSuggestionSchema = TaskSuggestionInputSchema.extend({
  kind: z.literal("task_suggestion"),
  status: z.enum(["pending", "starting", "started", "dismissed"]),
});
export type TaskSuggestion = z.infer<typeof TaskSuggestionSchema>;
